var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',[_c('div',{staticClass:"search-page page w-100 p-0 m-0"},[_c('banner'),_c('job-search-list',{staticClass:"search-page__list container"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }